import { IMPACT_SECTION_IDS } from '~/constants/impactSectionIds'

export type ImpactSectionBindingOptions = {
  inputTypeForIxId?: Record<string, string>
  normalizeValueByIxId?: Record<string, 'int' | 'float' | 'string' | 'date'>
  validatorByIxId?: Record<string, ((val: unknown) => boolean | string) | undefined>
  /** Hide from the main section dynamic form (e.g. rendered in a page #after slot). */
  excludeQuestionIxIds?: string[]
  /** When set, render only these question ix_ids (used for deferred slot rendering). */
  onlyQuestionIxIds?: string[]
}

const IMPACT_SECTION_BINDINGS: Partial<
  Record<number, ImpactSectionBindingOptions>
> = {
  [IMPACT_SECTION_IDS.carry]: {
    inputTypeForIxId: {
      startingYear: 'number',
      durationYears: 'number',
    },
    normalizeValueByIxId: {
      initialInvestmentDate: 'date',
      startingYear: 'int',
      durationYears: 'int',
      carryRemarks: 'string',
    },
    excludeQuestionIxIds: ['carryRemarks'],
  },
  [IMPACT_SECTION_IDS.emissionSources]: {
    normalizeValueByIxId: {
      emissionSourceLimitations: 'string',
    },
  },
  [IMPACT_SECTION_IDS.growthFactor]: {
    inputTypeForIxId: {
      durationOfImpact: 'number',
    },
    normalizeValueByIxId: {
      startingYear: 'int',
      ghgGrowthFactorStartingYear: 'int',
      durationOfImpact: 'float',
    },
  },
  [IMPACT_SECTION_IDS.fairComparison]: {
    normalizeValueByIxId: {
      needFulfilled: 'string',
      baselineSolutionDescription: 'string',
      comparativeUnit: 'string',
      describeComparison: 'string',
    },
  },
  [IMPACT_SECTION_IDS.impactProfile]: {
    normalizeValueByIxId: {
      impactProfileKind: 'string',
    },
  },
}

export function getImpactSectionBindings(
  sectionId: number,
): ImpactSectionBindingOptions {
  return IMPACT_SECTION_BINDINGS[sectionId] ?? {}
}
